import React, { useEffect, useState, Fragment, useRef } from "react";
import { BlockWeighmentTableContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const contentRowNames = this.props.rowNames;
        const reportData = this.props.reportData;

        return (
            <div>
                <h3 className="pr-2"><center><u>Block Weighment Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Esate: </b> {searchData.estate}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>Division: </b> {searchData.division === undefined ? "All Divisions" : searchData.division}</div>
                    <div className="col"><b>Field: </b> {searchData.field === undefined ? "All Fields" : searchData.field}</div>
                    <div className="col"><b>Registartion Number: </b> {searchData.regNumber.legth === 0 ? "Any Reg Number" : searchData.regNumber}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <table id="blockWeighment" className="display dataTable no-footer">
                        <thead>
                            <tr>
                                <th> Registration Number</th>
                                <th> <center>Name</center> </th>
                                <th> <center>Field Name</center></th>
                                <th> <center>Bag Count</center></th>
                                <th> <center>Gross Weight</center></th>
                                <th> <center>Total Deduction</center> </th>
                                <th> <center>Net Weight</center></th>
                                <th> <center>Total Weight</center> </th>
                            </tr>
                        </thead>
                        <tbody>
                            <BlockWeighmentTableContent
                                data={reportData}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}